// Shared metadata for /agenda sub-components.
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const PROGRAMS = [
  { slug: 'e-personalidade', name: 'E-Personalidade', icon: 'solar:user-circle-linear' },
  { slug: 'e-processual', name: 'E-Processual', icon: 'solar:graph-up-linear' },
  { slug: 'e-corpo', name: 'E-Corpo', icon: 'solar:dumbbell-large-linear' },
  { slug: 'e-vendas', name: 'E-Vendas', icon: 'solar:cart-large-2-linear' },
  { slug: 'e-got', name: 'E-GOT', icon: 'solar:crown-line-linear' },
];

export const PROGRAM_BY_SLUG = Object.fromEntries(PROGRAMS.map((p) => [p.slug, p]));

export const MODALITIES = [
  { value: '', label: 'Todas' },
  { value: 'presencial', label: 'Presencial' },
  { value: 'online', label: 'Online' },
  { value: 'intensivo', label: 'Intensivo' },
  { value: 'extensivo', label: 'Extensivo' },
];

export const formatDateRange = (start, end) => {
  if (!start) return '';
  const opt = { day: '2-digit', month: 'long', year: 'numeric' };
  const a = new Date(start);
  if (!end) return a.toLocaleDateString('pt-BR', opt);
  const b = new Date(end);
  const sameMonth = a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
  if (sameMonth) {
    return `${a.getDate()} a ${b.getDate()} de ${a.toLocaleDateString('pt-BR', {
      month: 'long',
    })}, ${a.getFullYear()}`;
  }
  return `${a.toLocaleDateString('pt-BR', opt)} a ${b.toLocaleDateString('pt-BR', opt)}`;
};

export { format, parseISO, ptBR };
